import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/findBasicConfigData`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findUniversityQueryList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/shanghaiPlan/findUniversityQueryList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/shanghaiPlan/selectProgramInfo`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  sendScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/sendScheme`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetailEdit({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/shanghaiPlan/selectProgramInfoEdit`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectEstimateSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/shanghaiPlan/selectSchemeList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/shanghaiPlan/save`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findProfessionList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/shanghaiPlan/findProfessionList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetailForNewPlanByLastStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/shanghaiPlan/selectProgramInfoLast`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findIdBySpecialityName({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/profession/findIdBySpecialityName`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  recommendScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/updateRecommendStatus`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  exportScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/art/shanghaiPlan/exportScheme",
        data: params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};
